



















import { EssaySupportText } from '@/store/modules/essay/state';
import Vue, { PropType } from 'vue';
import VueMarkdown from 'vue-markdown';

export default Vue.extend({
  components: {
    VueMarkdown,
  },
  props: {
    supportTexts: {
      type: Array as PropType<EssaySupportText[]>,
      default: () => [],
    },
  },
});
